import React from 'react';
import Typography from '@mui/material/Typography';

import { FlexColumn } from 'src/components/flex';
import SpaceshipImage from 'src/pages/landlord/conversations/components/list/Spaceship';

type Props = {
    text?: string;
};

export default function ConversationsNoSearchResults({ text }: Props) {
    text = text || 'No conversations found. Try adjusting your search or filter to find what you\'re looking for.';
    return (
        <FlexColumn px={1} alignItems="center" rowGap={2} maxWidth="100%" flexWrap="nowrap">
            <SpaceshipImage />
            <Typography>{text}</Typography>
        </FlexColumn >
    );
}
